import React, { useEffect, useState } from "react";
import { Submitbtn } from "../../../Component";
import { InputField } from "../../../Component";
import DropDown from "../../../Component/dropdown";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import AddMoreBtn from "../../../Component/addMoreBtn";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ImgPickerAndViewer from "../../../Component/imgPickerAndViewer";
import {
  validateAgeGrp,
  validateIsFileImageType,
} from "../../../Utils/validators";
import { validateIsFileImageTypeErrMsg } from "../../../Utils/errorMsg";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { uploadFile } from "../../../Screen/Superadmin/superAdminSlice";
import {
  addSubCategory,
  getCategoryList,
  getProductTypeList,
} from "../adminSlice";

const AddSubCategory = () => {
  const initialVal = [
    {
      name: "",
      order: "",
      image: "",
    },
  ];
  const dispatch: Function = useDispatch<AppDispatch>();
  const [subCategoryArr, setSubCategoryArr] = useState<any>(initialVal);
  const [productTypeList, setProductTypeList] = useState<any>([]);
  const [productType, setProductType] = useState<any>("");
  const [category, setCategory] = useState<any>("");
  const [categoryList, setCategoryList] = useState<any>([]);
  useEffect(() => {
    dispatch(
      getProductTypeList({
        callback: (res: any) => {
          setProductTypeList(res?.data);
        },
        errorCallback: () => {},
      })
    );
    // dispatch(
    //   getCategoryList({
    //     callback: (res: any) => {
    //       setCategoryList(res?.data);
    //     },
    //     errorCallback: () => {},
    //   })
    // );
  }, []);
  const onchangeProductType = (value: any) => {
    setProductType(value);
      const postData = {
          productTypeId: value?._id,
        };
        dispatch(
          getCategoryList({
            params: postData,
            callback: (res: any) => {
              setCategoryList(res);
            },
            errorCallback: (error: any) => {},
          })
        );
  };
  const onchangeCategory = (value: any) => {
    setCategory(value);
  };

  const onchangeSubCategory = (value: any, index: any, key: any) => {
    let newArr = JSON.parse(JSON.stringify(subCategoryArr));
    if (key === "image") {
      if (!validateIsFileImageType(value)) {
        return;
      } else {
        const reader = new FileReader();
        const file = value.target.files[0];
        reader.onloadend = () => {
          newArr[index][key] = reader.result;
          setSubCategoryArr(newArr);
        };
        reader.readAsDataURL(file);
        dispatch(
          uploadFile({
            params: file,
            callback: (res: any) => {
              if (res) {
                newArr[index][key] = res?.url;
                setSubCategoryArr(newArr);
              }
            },
            errorCallback: () => {},
          })
        );
      }
    } else if (key === "order") {
      if (validateAgeGrp(value)) {
        newArr[index][key] = value;
        setSubCategoryArr(newArr);
      }
    } else if (key === "name") {
      newArr[index][key] = value;
      setSubCategoryArr(newArr);
    }
  };
  const onPressAdd = () => {
    setSubCategoryArr([...subCategoryArr, initialVal[0]]);
  };
  const handleClose = (index: any) => {
    const newArray = [...subCategoryArr];
    if (index > -1) {
      newArray.splice(index, 1);
    }
    setSubCategoryArr(newArray);
  };
  const handleSubmit = (e: any) => {
    e.preventDefault();
    const postData = {
      productTypeId: productType?._id,
      categoryID: category?._id,
      book: subCategoryArr,
    };
    dispatch(
      addSubCategory({
        params: postData,
        callback: (res: any) => {
          setSubCategoryArr(initialVal);
          setProductType("");
          setCategory("");
        },
        errorCallback: (error: any) => {},
      })
    );
  };
  const validations = () => {
    if (productType === "" || category === "") {
      return true;
    }
    let subCategoryFormatArr: boolean = false;
    subCategoryArr?.map((item: any) => {
      if (item?.name === "" || item?.order === "" || item?.image === "") {
        subCategoryFormatArr = true;
      }
    });
    return subCategoryFormatArr;
  };

  const renderForm = () => {
    return (
      <form onSubmit={handleSubmit}>
        <div className="row align-items-center">
          <div className="col-md-10">
            <div className="col-md-5  m-3 p-3 ms-0">
              <div className="me">
                <LabelInput labelName={"Product Type"} isRequired />
                <DropDown
                  labelName={"Select Product Type"}
                  setInputText={(value: any) => onchangeProductType(value)}
                  options={productTypeList}
                  value={productType}
                />
              </div>
              <div className="me mt-3">
                <LabelInput labelName={"Category "} isRequired />
                <DropDown
                  labelName={"Select Category "}
                  setInputText={(value: any) => onchangeCategory(value)}
                  options={categoryList}
                  value={category}
                />
              </div>
            </div>

            {subCategoryArr.map((item: any, index: any) => {
              const { name, order, image } = item;
              return (
                <div className=" d-flex ">
                  <div className="col-md-5 border rounded m-3 p-3 ms-0">
                    <div className="">
                      <div className="me">
                        <LabelInput
                          labelName={"Sub Category Name"}
                          isRequired
                        />
                        <InputField
                          key={"ex2"}
                          placeholder={"Enter Sub Category Name"}
                          setInputText={(value: any) =>
                            onchangeSubCategory(value, index, "name")
                          }
                          value={name}
                        />
                      </div>

                      <div className="d-flex mt-3">
                        <div className="col-md-6 mb-3">
                          <LabelInput labelName={"Order number"} isRequired />
                          <InputField
                            key={"ex2"}
                            placeholder={`Order  No. ${index + 1}`}
                            setInputText={(value: any) =>
                              onchangeSubCategory(value, index, "order")
                            }
                            value={order}
                          />
                        </div>
                        <div className="col-md-6 mb-3 ms-5">
                          <LabelInput labelName={"Image"} isRequired />
                          <ImgPickerAndViewer
                            value={image}
                            handleChange={(value: any) =>
                              onchangeSubCategory(value, index, "image")
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {subCategoryArr?.length === 1 ? (
                    ""
                  ) : (
                    <DeleteForeverIcon
                      className="text-danger  mt-3"
                      onClick={() => handleClose(index)}
                    />
                  )}
                </div>
              );
            })}

            <div className="col-md-5 d-flex justify-content-end ">
              <div className="col-2 pt-2">
                <AddMoreBtn handleClick={onPressAdd} />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-1 mx-auto my-4">
          <Submitbtn name={"Submit"} disabled={validations()} />
        </div>
      </form>
    );
  };

  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle name={"Sub Category "} />
      </div>
      <div className="formDiv bxshadow">
        <div className=" p-2 borderRadius mb-4 ">{renderForm()}</div>
      </div>
    </div>
  );
};

export default AddSubCategory;
